import { Avatar, Chip, Typography } from '@mui/material';
import React from 'react';
import { getCardColors } from '../../utils/common';
import { CourseType } from '../../types/course';
import { SkillLevel } from '../../types/skill-level';
import { LevelIconSelector } from '../../utils/select-level-icon';
import { SkilllevelsType } from 'src/shared/types/course';

const DifficultyLevelChip = ({
  courseType,
  level,
  highlighted,
}: {
  courseType: CourseType;
  level: SkillLevel['name'];
  highlighted: boolean;
}) => {
  const colors = getCardColors(courseType, highlighted);
  return (
    <Chip
      size="small"
      label={
        <Typography variant="button-s" className="capitalize ml-1">
          {level}
        </Typography>
      }
      avatar={
        <Avatar
          src={LevelIconSelector(level?.toLowerCase() as SkilllevelsType, courseType, highlighted)}
          sx={{ borderRadius: 0 }}
        />
      }
      sx={{
        background: colors?.courseLevelChipBgColor,
        color: colors?.courseLevelChipTextColor,
      }}
    />
  );
};

export default DifficultyLevelChip;
